var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketdownarrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.172188 1.41584L0.279062 1.53622L8.35406 10.507C8.62719 10.8108 9.03687 11 9.49406 11C9.95125 11 10.3609 10.8051 10.6341 10.507L18.7031 1.55341L18.8397 1.40438C18.9406 1.26107 19 1.08911 19 0.90568C19 0.406983 18.5606 0 18.0144 0H0.985625C0.439375 0 0 0.406983 0 0.90568C0 1.09484 0.0653126 1.27254 0.172188 1.41584Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.172188 1.41584L0.279062 1.53622L8.35406 10.507C8.62719 10.8108 9.03687 11 9.49406 11C9.95125 11 10.3609 10.8051 10.6341 10.507L18.7031 1.55341L18.8397 1.40438C18.9406 1.26107 19 1.08911 19 0.90568C19 0.406983 18.5606 0 18.0144 0H0.985625C0.439375 0 0 0.406983 0 0.90568C0 1.09484 0.0653126 1.27254 0.172188 1.41584Z",
    fill: "url(#paint0_linear_3096_27016)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3096_27016",
    x1: 4.03495,
    y1: 1.77419,
    x2: 8.68397,
    y2: 12.8012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E96114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B80000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketdownarrow);
export default __webpack_public_path__ + "static/media/marketdownarrow.2b3be88c5e699b7818ac6cb51a0f48c1.svg";
export { ForwardRef as ReactComponent };